
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-partner-program",
      function () {
        return require("private-next-pages/whatsapp-partner-program.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-partner-program"])
      });
    }
  